
import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
// import { serverError } from './components/Entryfile/imagepath'
import Login from "./components/initialpage/Login";
//------------------------------- transport section start----------------------------------------

// -------------------------------------- end --------------------------------------------

import Cookies from "js-cookie";
import swal from "sweetalert";
import useAuth from "./components/initialpage/hooks/useAuth";
import AdministrationLandingPage from "./components/initialpage/LandingPage/AdministrationLandingPage";
import Logout from "./components/initialpage/Logout";
import NotFound from "./components/initialpage/NotFound";
import ServerError from "./components/initialpage/ServerError/ServerError";
import 'font-awesome/css/font-awesome.min.css';
import './components/assets/css/font-awesome.min.css';
import './components/assets/css/line-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./components/assets/css/bootstrap.min.css";
// Custom Style File
import './components/assets/css/select2.min.css';


import "./components/assets/plugins/bootstrap-tagsinput/bootstrap-tagsinput.css";
import "./components/assets/css/bootstrap-datetimepicker.min.css";
import './components/assets/css/style.css';
import StoreApp from "./StoreApp";
import Dashboard from "./components/MainPage/Store/Dashboard/Dashboard";
import StockLess from "./components/MainPage/Store/Warehouse/StockLess/StockLess";
import Categories from "./components/MainPage/Store/Common/Settings/Categories/Categories";
import ProductList from "./components/MainPage/Store/Common/Settings/ProductList/ProductList";
import ViewList from "./components/MainPage/Store/Common/Settings/ProductList/ViewList/ViewList";
import StoreHeader from "./components/MainPage/Store/StoreComponents/StoreHeader";
import StoreSidebar from "./components/MainPage/Store/StoreComponents/StoreSidebar";
import Unit from "./components/MainPage/Store/Common/Settings/Unit/Unit";
import RoleSet from "./components/MainPage/Store/Common/Settings/RoleSet/RoleSet";
import Suppliers from "./components/MainPage/Store/Common/Settings/Suppliers/Suppliers";
import UserProfiles from "./components/MainPage/Store/StoreAdmin/SystemAccess/UserProfiles/UserProfiles";
import ProfileCategoryList from "./components/MainPage/Store/StoreAdmin/SystemAccess/UserProfiles/ProfileCategoryList/ProfileCategoryList";
import ViewAllowedProduct from "./components/MainPage/Store/StoreAdmin/SystemAccess/UserProfiles/ViewAllowedProduct/ViewAllowedProduct";
import SignatureAdd from "./components/MainPage/Store/StoreAdmin/SystemAccess/SignatureAdd/SignatureAdd";
import PendingRequisition from "./components/MainPage/Store/StoreAdmin/Requisitions/PendingRequisition/PendingRequisition";
import ViewPendingRequisition from "./components/MainPage/Store/StoreAdmin/Requisitions/PendingRequisition/ViewPendingRequisition/ViewPendingRequisition";
import ApprovedRequisition from "./components/MainPage/Store/StoreAdmin/Requisitions/ApprovedRequisition/ApprovedRequisition";
import ViewCheckout from "./components/MainPage/Store/StoreAdmin/Requisitions/ApprovedRequisition/ViewCheckout/ViewCheckout";
import DoneRequisition from "./components/MainPage/Store/StoreAdmin/Requisitions/DoneRequisition/DoneRequisition";
import DoneRequisitionSlip from "./components/MainPage/Store/StoreAdmin/Requisitions/DoneRequisition/DoneRequisitionSlip/DoneRequisitionSlip";
import DeniedRequisition from "./components/MainPage/Store/StoreAdmin/Requisitions/DeniedRequisition/DeniedRequisition";
import ManualRequisition from "./components/MainPage/Store/StoreAdmin/Requisitions/ManualRequisition/ManualRequisition";
import NotGiven from "./components/MainPage/Store/StoreAdmin/Requisitions/NotGiven/NotGiven";
import ProductEntiesAll from "./components/MainPage/Store/Warehouse/Reports/ProductEntiesAll/ProductEntiesAll";
import ProductEntiesSingle from "./components/MainPage/Store/Warehouse/Reports/ProductEntiesSingle/ProductEntiesSingle";
import RequisitionRepDate from "./components/MainPage/Store/Warehouse/Reports/RequisitionRepDate/RequisitionRepDate";
import RequisitionRepProduct from "./components/MainPage/Store/Warehouse/Reports/RequisitionRepProduct/RequisitionRepProduct";
import RequisitionRepProductDate from "./components/MainPage/Store/Warehouse/Reports/RequisitionRepProductDate/RequisitionRepProductDate";
import RequisitionRepPerson from "./components/MainPage/Store/Warehouse/Reports/RequisitionRepPerson/RequisitionRepPerson";
import RequisitionRepPersonDate from "./components/MainPage/Store/Warehouse/Reports/RequisitionRepPersonDate/RequisitionRepPersonDate";
import LogsProduct from "./components/MainPage/Store/Warehouse/Reports/LogsProduct/LogsProduct";
import LogsMonthly from "./components/MainPage/Store/Warehouse/Reports/LogsMonthly/LogsMonthly";
import LogsCategory from "./components/MainPage/Store/Warehouse/Reports/LogsCategory/LogsCategory";
import StockStatusAll from "./components/MainPage/Store/Warehouse/Reports/StockStatusAll/StockStatusAll";
import StockStatusCategory from "./components/MainPage/Store/Warehouse/Reports/StockStatusCategory/StockStatusCategory";
import NewEntry from "./components/MainPage/Store/Warehouse/Products/NewEntry/NewEntry";
import ExistingEntry from "./components/MainPage/Store/Warehouse/Products/ExistingEntry/ExistingEntry";
import StockProducts from "./components/MainPage/Store/Warehouse/Products/StockProducts/StockProducts";
import StockProductListByID from "./components/MainPage/Store/Warehouse/Products/StockProducts/StockProductListByID/StockProductListByID";
import ManageSupplier from "./components/MainPage/Store/Warehouse/Products/MRR_Product/ManageSupplier";
import AddMoreMRR from "./components/MainPage/Store/Warehouse/Products/MRR_Product/AddMoreMRR/AddMoreMRR";
import MrrProductReceipt from "./components/MainPage/Store/Warehouse/Products/MRR_Product/MrrProductReceipt/MrrProductReceipt";
import ViewRecentMrr from "./components/MainPage/Store/Warehouse/Products/MRR_Product/ViewRecentMrr/ViewRecentMrr";
import UpdateViewMrr from "./components/MainPage/Store/Warehouse/Products/MRR_Product/ViewRecentMrr/UpdateViewMrr/UpdateViewMrr";
import NewRequisition from "./components/MainPage/Store/Requisitionar/NewRequisition/NewRequisition";
import ViewRequisition from "./components/MainPage/Store/Requisitionar/ViewRequisition/ViewRequisition";
import UserReports from "./components/MainPage/Store/Requisitionar/UserReports/UserReports";
import ProductWiseReport from "./components/MainPage/Store/Requisitionar/ProductWiseReport/ProductWiseReport";
import RequestProduct from "./components/MainPage/Store/Requisitionar/RequestProduct/RequestProduct";
import RequestProUser from "./components/MainPage/Store/Requisitionar/RequestProduct/RequestProUser";
import RequestProductRepView from "./components/MainPage/Store/Requisitionar/RequestProduct/RequestProductRepView";
import ViewPendingRequest from "./components/MainPage/Store/Requisitionar/RequestProduct/ViewPendingRequest";
import UserReqSlip from "./components/MainPage/Store/Requisitionar/UserReports/UserReqSlip/UserReqSlip";
import SingleViewRequisition from "./components/MainPage/Store/Requisitionar/ViewRequisition/SingleViewRequisition/SingleViewRequisition";
import ProjectAssetEntry from "./components/MainPage/Store/Warehouse/Products/ProjectAsset/ProjectAssetEntry";
import ProjectAssetView from "./components/MainPage/Store/Warehouse/Products/ProjectAsset/ProjectAssetView";
import ProjectAssetViewById from "./components/MainPage/Store/Warehouse/Products/ProjectAsset/ProjectAssetViewById";
import EmployeeDashboard from "./components/MainPage/Main/Dashboard/employeedashboard";
import AdminDashboard from "./components/MainPage/Main/Dashboard/Admindashboard";
import AllEmployees from "./components/MainPage/Employees/Employees/Allemployees";
import Employeeslist from "./components/MainPage/Employees/Employees/employeeslist";
import EmployeeInformationForm from "./components/MainPage/Employees/EmployeeInformationForm/EmployeeInformationForm";
import AllEmployeeReports from "./components/MainPage/Employees/Employees/AllEmployeeReports";
import UserAdd from "./components/MainPage/Administration/Settings/UserAdd";
import Designation from "./components/MainPage/Administration/Settings/Designation";
import Department from "./components/MainPage/Administration/Settings/Department";
import AddSignature from "./components/MainPage/Administration/Settings/AddSingnature";
import Role from "./components/MainPage/Administration/Settings/Role";
import Test from "./Test";
import AddSubModule from "./components/MainPage/Administration/Settings/AddSubModule";
import EmployeeProfile from "./components/MainPage/Employees/Employees/employeeprofile";
import SingleProfile from "./components/MainPage/Employees/Employees/SingleProfile";
import ChangePassword from "./components/MainPage/Administration/Settings/ChangePassword";
import NotFoundPage from "./components/MainPage/Store/StoreComponents/NotFoundPage";

function App(props) {
  const { user } = useAuth();
  const isLoggedIn = parseInt(Cookies.get("Role"));
  const empID = parseInt(Cookies.get("E_Id"));

  if (isLoggedIn && empID) {
    return (
      <div className="App">
        {/* <Routes>
         
          <Route path="/" element={<StoreApp />} />
          <Route path="/logout" element={<Logout />} />

        </Routes> */}
        <div className="App mt-4 text-start">
          {isLoggedIn && empID ? (
            <>
              <StoreHeader />
              <StoreSidebar />
            </>
          ) : (
            ""
          )}
          {isLoggedIn && empID ? (
            <Routes>
              <Route exact path="/" element={<Dashboard />} />
              <Route path="/store" element={<Dashboard />} />
              <Route path="/viewstocklessproducts" element={<StockLess />} />
              <Route path="/settings/categories" element={<Categories />} />
              <Route path="/settings/productList" element={<ProductList />} />
              <Route path="/settings/productList/:cat_id" element={<ViewList />} />
              <Route path="/settings/unit" element={<Unit />} />
              <Route path="/roleSet" element={<RoleSet />} />
              <Route path="/settings/suppliers" element={<Suppliers />} />
              <Route path="/systemaccess/userprofile" element={<UserProfiles />} />
              <Route
                path="/systemaccess/userprofile/category/:empId"
                element={<ProfileCategoryList />}
              />
              <Route
                path="/systemaccess/userprofile/:empId"
                element={<ViewAllowedProduct />}
              />
              <Route path="/systemaccess/signatureAdd" element={<SignatureAdd />} />
              {/* <Route path="/allRequisition" element={<RequisitionList />}/> */}
              <Route
                path="/requisitions/pending"
                element={<PendingRequisition />}
              />
              <Route
                path="/requisitions/pending/viewPendingRequisition/:requ_id"
                element={<ViewPendingRequisition />}
              />
              <Route
                path="/requisitions/approved"
                element={<ApprovedRequisition />}
              />
              <Route
                path="/requisitions/approved/viewCheckout/:requisition_id"
                element={<ViewCheckout />}
              />
              <Route path="/requisitions/done" element={<DoneRequisition />} />
              <Route
                path="/requisitions/done/slip/:req_id"
                element={<DoneRequisitionSlip />}
              />
              <Route path="/requisitions/denied" element={<DeniedRequisition />} />
              <Route path="/requisitions/manual" element={<ManualRequisition />} />
              <Route path="/requisitions/notgiven" element={<NotGiven />} />

              <Route
                path="/reports/entries/allproduct"
                element={<ProductEntiesAll />}
              />
              <Route
                path="/reports/entries/singleproduct"
                element={<ProductEntiesSingle />}
              />
              <Route
                path="/reports/requisitions/datewise"
                element={<RequisitionRepDate />}
              />
              <Route
                path="/reports/requisitions/productwise"
                element={<RequisitionRepProduct />}
              />
              <Route
                path="/reports/requisitions/productdatewise"
                element={<RequisitionRepProductDate />}
              />
              <Route
                path="/reports/requisitions/personwise"
                element={<RequisitionRepPerson />}
              />
              <Route
                path="/reports/requisitions/persondatewise"
                element={<RequisitionRepPersonDate />}
              />
              <Route path="/reports/logs/product" element={<LogsProduct />} />
              <Route path="/reports/logs/monthly" element={<LogsMonthly />} />
              <Route path="/reports/logs/category" element={<LogsCategory />} />
              <Route path="/reports/stockStatus/all" element={<StockStatusAll />} />
              <Route
                path="/reports/stockStatus/category"
                element={<StockStatusCategory />}
              />

              <Route path="/product/addNew" element={<NewEntry />} />
              <Route path="/product/addExisting" element={<ExistingEntry />} />
              <Route path="/product/manageProducts" element={<StockProducts />} />
              <Route
                path="/product/cateproducts/:cat_id"
                element={<StockProductListByID />}
              />

              {/* MRR  */}
              <Route path="/manageSupplier" element={<ManageSupplier />} />
              <Route
                path="/manageSupplier/addMoreMrr/:info"
                element={<AddMoreMRR />}
              />
              <Route
                path="/MrrProductReceipt/:mrrsup_id"
                element={<MrrProductReceipt />}
              />
              <Route path="/viewproductreceipt/:info" element={<ViewRecentMrr />} />
              <Route path="/editproductreceipt/:info" element={<UpdateViewMrr />} />

              {/* MRR  */}
              <Route path="/requisition/create" element={<NewRequisition />} />
              <Route path="/requisition/view" element={<ViewRequisition />} />
              <Route path="/requisition/userReport" element={<UserReports />} />
              <Route
                path="/requisition/productWiseReport"
                element={<ProductWiseReport />}
              />
              <Route
                path="/requisition/requestProduct"
                element={<RequestProduct />}
              />
              <Route
                path="/requisition/requestProduct/user"
                element={<RequestProUser />}
              />
              <Route
                path="/requisition/requestProduct/slip/:req_id"
                element={<RequestProductRepView />}
              />
              <Route
                path="/requisitions/requestProduct/viewPendingRequest/:request_id"
                element={<ViewPendingRequest />}
              />
              <Route
                path="/requisition/userReport/slip/:req_id"
                element={<UserReqSlip />}
              />
              <Route
                path="/viewrequisitionstatus/:view_id"
                element={<SingleViewRequisition />}
              />
              <Route path="/projectassetentry" element={<ProjectAssetEntry />} />
              <Route path="/projectassetmanage" element={<ProjectAssetView />} />
              <Route
                path="/projectassetmanage/view/:asset_id"
                element={<ProjectAssetViewById />}
              />

              {/* HR ROUTES START */}
              <Route exact path="/hr" element={<EmployeeDashboard />} />
              <Route exact path="/hr/admindashboard" element={<AdminDashboard />} />
              <Route path="/hr/employeedashboard" element={<EmployeeDashboard />} />
              <Route path="/hr/allemployees" element={<AllEmployees />} />
              <Route path="/hr/employeeslist" element={<Employeeslist />} />
              <Route path="/hr/employeeinformationform" element={<EmployeeInformationForm />} />
              <Route path="/hr/allemployeesreports" element={<AllEmployeeReports />} />
              <Route path="/hr/usersadd" element={<UserAdd />} />
              <Route path="/hr/designation" element={<Designation />} />
              <Route path="/hr/department" element={<Department />} />
              <Route path="/hr/signature" element={<AddSignature />} />
              <Route path="/hr/allrole" element={<Role />} />
              <Route path="/hr/test" element={<Test />} />
              <Route path="/hr/addsubmodule" element={<AddSubModule />} />
              <Route path="/hr/employeeprofile/:EmpID" element={<EmployeeProfile />} />
              <Route path="/hr/singleprofile" element={<SingleProfile />} />
              <Route path="/hr/changepassword" element={<ChangePassword />} />
              <Route path="/hr/*" element={<NotFoundPage />} />
              {/* HR ROUTES END */}

              <Route path="/logout" element={<Logout />} />
            </Routes>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
